import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const peFamilySectionActions = {
  peFamilySectionCreateParty: async (_, { party, recordId, legalCaseId }) => {
    return axiosRequest.
      post('/parties', { party, record_id: recordId, legal_case_id: legalCaseId }).
      then(({ data }) => data.party).
      catch(handleError)
  },
}
export const peFamilySectionGetters = {}
export const peFamilySectionMutations = {}
